<template>
  <div>
    <answer-render ref="answer" :config="config">
      <div slot="body">
        <FormItem prop="value" :rules="rules">
          <div class="input-wrapper">
            <input class="input-answer" v-model="config.value" @input="inputChange" @blur="blur">
            <span v-if="config.unit" class="unit">{{ cvtLang(config.id + '-unit', config.unit) }}</span>
          </div>
        </FormItem>
      </div>
    </answer-render>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import answerValidate from './answerValidate'
import util from '@/tools/commonUtil'

export default {
  name: 'NumberBoxAnswer',
  props: ['config'],
  data () {
    return {
      rules: [
        {
          validator: (rule, value, callback) => {
            const errors = answerValidate.validate.bind(this.config)(this).errors
            if (errors.length) {
              return callback(errors)
            }
            return callback()
          }
        }
      ]
    }
  },
  components: {},
  watch: {},
  computed: {
    ...mapGetters(['allQuestionList']),
    ...mapState({
      answerStyleConfig: ({ Question }) => Question.answerStyleConfig,
      answerTypeList: ({Question}) => Question.answerTypeList,
      lang: ({Question}) => Question.lang,
      surveyInfoLang: ({Question}) => Question.surveyInfoLang, // 基础语言配置（提示文字、按钮、题型）
      langMap: ({Question}) => Question.langMap
    })
  },
  methods: {
    inputChange() {
      sessionStorage.setItem('allOrderByIdStash', this.config.allOrderById)
    },
    blur() {
      const {scoreNumType} = this.config.answerConfig
      if (this.config.value && !this.config.value.trim()) {return}
      if (scoreNumType === '02') {
        this.config.value = util.formatNumber(this.config.value, 1)
      } else if (scoreNumType === '03') {
        this.config.value = util.formatNumber(this.config.value, 2)
      }
    },
    // TODO 引用/继承
    isOrigin () {
      return this.lang === 'origin'
    },
    // TODO 引用/继承
    cvtLang: function (id, title) {
      if (this.isOrigin()) {
        return title
      }
      const {lang, langMap} = this
      const key = `${id}_${lang}`
      const value = langMap[key]
      if (!value) {
        this.$set(langMap, key, '')
      }
      return langMap[key]
    },
  },
  created () {},
  mounted () {}
}
</script>
<style lang="scss" scoped>

.input-wrapper {
  margin-top: 40px;
  .input-answer {
    height: 64px;
    padding: 0 20px;
    line-height: 64px;
    width: 320px;
    outline: none;
    border: 1px solid #C2C2C2;
    border-radius: 4px;

    font-size: 28px;
    font-weight: 500;
  }

  .unit {
    margin-left: 20px;
    color: #000;
    font-size: 28px;
    font-weight: 500;
  }
  
}
.answer-pc {
  .input-wrapper {
    margin-top: 10px;
    .input-answer {
      height: 32px;
      padding: 0 10px;
      line-height: 32px;
      width: 160px;
      border-radius: 2px;
      font-size: 14px;
    }
    .unit {
      font-size: 14px;
      margin-left: 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/editor/NumberBox/NumberBoxAnswer.vue